// extracted by mini-css-extract-plugin
export default {"button":"Vr-z","reviewSort":"Wr-z"};